import React from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
import { MEDIA_BASE_URL } from '../../../api'
import '../productPages.css'

function Nepal() {
    const images = ['Slide001', 'Slide002', 'Slide003', 'Slide004', 'Slide005', 'Slide006', 'Slide007', 'Slide008', 'Slide009', 'Slide010', 'Slide011', 'Slide012', 'Slide013', 'Slide014', 'Slide015']
    return (
        <div>
            <Navbar />
            <div className='pp-gallery'>
                {images.map((image, index) => (
                    <img key={index} src={`${MEDIA_BASE_URL}/machines-images/Slaughterhouse/Nepal/${image}.jpeg`} alt={`Slide ${index + 1}`} loading='lazy' />
                ))}
            </div>
            <Footer />
        </div>
    )
}

export default Nepal
